<script lang="ts">
	import { selectedClientStore } from '../../../api/EnzianDataApi';
	import DefaultButton from '../../../basic/buttons/DefaultButton.svelte';
	import Modal from '../../../basic/modal/Modal.svelte';
	import ModalHeader from '../../../basic/modal/ModalHeader.svelte';
	import { createFolderListStore, type FolderListStore } from '../../../stores/FolderStore.svelte';
	import type { Folder } from '../../../types/FolderTypes';
	import { _ } from 'svelte-i18n';
	import FolderList from './FolderList.svelte';

	let usedFolder: Folder | null = null;
	let folderListStore: FolderListStore = $state(
		createFolderListStore(false, (item: Folder | null) => {
			usedFolder = item;
		})
	);

	interface Props {
		onModalClose?: () => void;
		onFolderSelected: (usedfolder: Folder) => void;
	}

	let { onModalClose = undefined, onFolderSelected }: Props = $props();

	function hideModal() {
		onModalClose?.();
	}
</script>

<Modal onModalClose={() => onModalClose?.()}>
	{#snippet header()}
		<ModalHeader text={$_('folderview.folder_modal.header')} />
	{/snippet}
	{#snippet content()}
		<div style="height: 70vh" class="grid">
			{#if $selectedClientStore}
				<FolderList
					client={$selectedClientStore}
					bind:folderListStore
					onSelectionChanged={(folder: Folder) => {
						usedFolder = folder;
					}}
				/>
			{/if}
		</div>
	{/snippet}
	{#snippet footer()}
		<div>
			<!-- Buttons -->
			<div class="flex justify-end gap-4">
				<DefaultButton secondary={true} onClick={hideModal} text={$_('general.lbl_cancel')} />
				<DefaultButton
					onClick={() => {
						if (usedFolder) {
							onFolderSelected(usedFolder);
						}
					}}
					text={$_('general.lbl_accept')}
				/>
			</div>
		</div>
	{/snippet}
</Modal>
